module.exports = __webpack_public_path__ + "static/media/game(24).1c3a5585.PNG";